export default __webpack_public_path__ + "static/footer-2-ee0184fe9f878602186e9ba6763b5d5e.jpg";